import { useState } from "react";
import { Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { updateDatasetStep } from "../../store/reducers/DatasetReducer";
import SystemMsg from "../SystemMsg";
import LocatorDropdownProps from "../DropdownProps";
import { resetLocatorUpload } from "../../store/reducers/LocatorsReducers";
import { addLocatorToDatasetAction } from "../../store/actions/LocatorsActions";
import {
  getUploadedLocatorData,
  getLocatorUploadStatus,
} from "../../store/selectors/LocatorSelectors";

const LocatorDetails = () => {
  const dispatch = useAppDispatch();
  const locatorUploadStatus = useAppSelector(getLocatorUploadStatus);
  const uploadedLocatorData = useAppSelector(getUploadedLocatorData);
  const [locatorDraft, updateLocatorDraft] = useState<any>({
    locatorid: uploadedLocatorData?.locatorid,
    imagetype: uploadedLocatorData?.imagetype,
    typeid: "undefined",
    lengthid: "undefined",
  });

  const isNextStepDisabled =
    locatorDraft.typeid === "undefined" ||
    locatorDraft.lengthid === "undefined";

  const onChooseLocatorType = (event: any) =>
    updateLocatorDraft({ ...locatorDraft, typeid: event.target.value });

  const onChooseLocatorLength = (event: any) =>
    updateLocatorDraft({ ...locatorDraft, lengthid: event.target.value });

  const onAddToDataset = () => {
    const formBody: any = [];

    Object.keys(locatorDraft).forEach((key) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(locatorDraft[key]);
      formBody.push(encodedKey + "=" + encodedValue);
    });

    dispatch(addLocatorToDatasetAction(formBody.join("&")));
    dispatch(updateDatasetStep(3));
  };

  const onCancelLocatorProcessing = () => {
    dispatch(resetLocatorUpload());
    dispatch(updateDatasetStep(1));
  };


  const locatorComponent = (
    <div className="locator-wrapper">
      <div className="nav-controls">
        <div className="left-side">
          <Button onClick={onCancelLocatorProcessing}>Back</Button>
        </div>
      </div>
      <div className="locator-details">
        <div className="left-side">
          <div className="locator-img">
            <img src={uploadedLocatorData?.path} alt="Locator" />
          </div>
        </div>
        <div className="right-side">
          <h2>Data labels</h2>
          <LocatorDropdownProps
            onChooseLocatorType={onChooseLocatorType}
            onChooseLocatorLength={onChooseLocatorLength}
            selectedLocatorType={locatorDraft.typeid}
            selectedLocatorLength={locatorDraft.lengthid}
          />
          <div className="locator-details-controls">
            <div className="row">
              <Button
                variant="contained"
                className="btn btn-blue"
                onClick={onAddToDataset}
                disabled={isNextStepDisabled}
              >
                Add to dataset
              </Button>
            </div>
            <div className="row">
              <Button
                className="btn btn-outlined"
                variant="outlined"
                onClick={onCancelLocatorProcessing}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return locatorUploadStatus === "error" ? <SystemMsg /> : locatorComponent;
};

export default LocatorDetails;
